import { Stack, Typography } from "@mui/material";
import type { InvestorCommunicationInfo } from "../../api/types/investorCommunicationsTypes";
import NewsItemImage from "./NewsItemImage";
import NewsItemLinkWrapper from "./NewsItemLinkWrapper";
import NewsItemMeta from "./NewsItemMeta";

interface Props {
  item: InvestorCommunicationInfo;
  to: string;
}

const NewsItemSummary = ({ item, to }: Props) => (
  <NewsItemLinkWrapper to={to} direction="row" spacing={3}>
    <NewsItemImage item={item} sx={{ width: 300, height: 200, flexShrink: 0 }} />
    <Stack spacing={1.5} sx={{ minWidth: 0 }}>
      <NewsItemMeta publishedAt={item.publishedAt} categories={item.categories} status={item.status} />
      <Typography variant="h5" className="news-item-title">
        {item.title}
      </Typography>
      {item.description && (
        <Typography variant="caption" color="textSecondary">
          {item.description}
        </Typography>
      )}
    </Stack>
  </NewsItemLinkWrapper>
);

export default NewsItemSummary;
